module.exports = __webpack_public_path__ + "img/refresh-3104.bd5a94c1.svg";